// @ts-nocheck
import Fetch from '@/utils/Fetch';
import Helper from '@/utils/helper';
import Storage from '@/utils/storage';
import * as Enums from '@/utils/enums';

const getAllReplacementTags = async (module: any) => {
    const request = await Fetch.get({
        url: `/Template/GetReplacementTagList?module=${module}`,
    });
    
    return {data: request.Results, total: request.TotalResults};
};

const _extractReplacementTags = (stringToTest: any) => {
    if (!stringToTest || typeof stringToTest !== 'string') return [];
    
    const regex = /\{\{+([^}]+)\}\}+/gi;
    const words = [];
    let match;

    while ((match = regex.exec(stringToTest)) !== null) {
        const word = match[1];
        if (!Helper.isNullOrWhitespace(word)) {
            words.push(word);
        }
    }
    return words;
};

const testForValidReplacementTags = (stringToTest: any, replacementTags: any) => {
    
    let tags = replacementTags.map((x: any) => x.Name.toLowerCase());

    let invalidTags = [];
    let excludedTags = ["paymentlink"];

    let words = _extractReplacementTags(stringToTest);

    for (let word of words) {
        let lowerCaseWord = (word as any).toLowerCase();
        if (!tags.includes(lowerCaseWord) && !excludedTags.includes(lowerCaseWord)) {                              
            invalidTags.push(("{{" as any) + word + "}}");                
        }
    }

    return invalidTags;
};

const testForValidSubject = (stringToTest: any) => {
    let words = _extractReplacementTags(stringToTest);
    let tagsNotAllowedForSubject = ["link", "paymentlink", "feedback", "feedbackresponse"];
    let invalidTags = [];

    for (let word of words) {
        let lowerCaseWord = (word as any).toLowerCase();
        if (tagsNotAllowedForSubject.includes(lowerCaseWord)) {
            invalidTags.push(("'") + word + "'");
        }
    }

    return invalidTags;
};

const getModuleMessageTemplate = (module: number, itemId: string | number, customerID: string | number, contactName?: string, itemIdentifier?: string, expiryDate?: string, documentType?: string) => {
    const tenantID = Storage.getCookie(Enums.Cookie.tenantID);
    const companyName = Storage.getCookie(Enums.Cookie.servCompanyName);
    const baseUrl = typeof window !== 'undefined' ? window.location.origin : 'https://app.servcraft.co.za';

    const contactStr = contactName || 'there';

    const moduleNum = +module;
    const isJob = moduleNum === Enums.Module.JobCard;
    const isQuote = moduleNum === Enums.Module.Quote;
    const isInvoice = moduleNum === Enums.Module.Invoice;

    if (isJob || isQuote || isInvoice) {
        let page = '';
        if (isJob) {
            page = 'viewjob';
        } else if (isQuote) {
            page = 'viewquote';
        } else if (isInvoice) {
            page = 'viewinvoice';
        }

        let czLink = `${baseUrl}/customerzone/${page}?t=${tenantID}&c=${customerID}&i=${itemId}`;

        if (documentType) {
            czLink += `&dt=${documentType}`;
        }

        if (isJob) {
            const identifier = itemIdentifier ? `Job Card ${itemIdentifier}` : 'your Job Card';
            return `Hi ${contactStr}, here is a link to ${identifier}: ${czLink}`;
        } else if (isQuote) {
            let message = `Hi ${contactStr}, see your quote from ${companyName} here: ${czLink}.`;
            if (expiryDate) {
                message += ` Quote valid until ${expiryDate}.`;
            }
            return message;
        } else if (isInvoice) {
            return `Hi ${contactStr}, see your invoice from ${companyName} here: ${czLink}.`;
        }
    }

    return `Hi ${contactStr}, just reaching out from ${companyName}.`;
};

export default {
    getAllReplacementTags,
    testForValidReplacementTags,
    testForValidSubject,
    getModuleMessageTemplate,
};
